import { projects_showcase as initializeBlock } from '../../blocks/projects-showcase/index.js';

const runBlock = () => initializeBlock(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runBlock, { once: true });
} else {
  runBlock();
}
